<template>
    <div>
      <b-loading :active.sync="loading" />
      <div class="w-full flex justify-between items-center">
        <Lynx-Title text="Exportação de relatórios" />
      </div>
  
      <div class="w-full flex mt-8 grid grid-cols-2 gap-8 items-start">
    
        <Card
        class="font-body cursor-pointer"
        color="primary-500"
        @click.native="ModelPosVendasComercial = true"
      >
        <div>
          <div class="p-6 flex items-start">
            <div class="flex flex-col ml-4">
              <p class="font-semibold pb-4 text-primary-800">
                Relatorios  Pós Vendas Comercial
              </p>
              <p class="font-semibold text-primary-800">
                <span class="text-neutral-800 font-normal text-neutral-700"
                  >Vendedor , etapa no pos cadastro, tempo que esta na etapa
                </span>
              </p>
            </div>
          </div>
        </div>
      </Card>

         <Card
        class="font-body cursor-pointer"
        color="primary-500"
        @click.native="exportRelatorio2('empresas/relatorioComercial')"
      >
        <div>
          <div class="p-6 flex items-start">
            <div class="flex flex-col ml-4">
              <p class="font-semibold pb-4 text-primary-800">
                Relatorios de todas as empresas Comercial
              </p>
              <p class="font-semibold text-primary-800">
                <span class="text-neutral-800 font-normal text-neutral-700"
                  >id,cnpj,razão social, criação e carteiras das empresas com status comercial
                </span>
              </p>
            </div>
          </div>
        </div>
      </Card>
     
  
      </div>
   
      <b-modal :active.sync="ModelPosVendasComercial" can-cancel>
      <div class="bg-neutral-300 shadow p-8">
        <div class="modal-body" style="height: 420px">
          <Lynx-Title text="Exportar" />

          <div class="w-full flex flex-wrap">
            <label class="flex flex-col w-2/4 pl-2 pb-6">
              <Lynx-Label label="Insira Vendedor" />

              <treeselect
                :multiple="false"
                :options="lista_usuarios"
                placeholder="Selecione Vendedor..."
                v-model="form.vendedor_id"
              />
            </label>
        <div class="w-full flex">
            <label class="flex flex-col w-1/2 pr-3 pb-6">
          <Lynx-Label
            label="Data de Início"
          />
          <b-datepicker
          size="sm"
            v-model="form.data_inicial"
            placeholder="Selecione uma data"
            :date-formatter="
              (date) => moment(date, 'YYYY/MM/DD').format('DD/MM/YYYY')
            "
            :date-parser="(date) => new Date(date)"
            :month-names="monthNames"
            :day-names="dayNames"
            :years-range="[-20, 10]"
          />
        </label>
        <label class="flex flex-col w-1/2 pl-3 pb-6">
          <Lynx-Label
            label="Data de final"
          />
          <b-datepicker
            calendar-width="100%"
               menu-class="w-100"
            v-model="form.data_final"
            placeholder="Selecione uma data"
            :date-formatter="
              (date) => moment(date, 'YYYY/MM/DD').format('DD/MM/YYYY')
            "
            :date-parser="(date) => new Date(date)"
            :month-names="monthNames"
            :day-names="dayNames"
            :years-range="[-20, 10]"
          />
        </label>
         
          </div>
          </div>
          <Lynx-Button
            text="Exportar"
            class="mr-2"
            @click.native="exportPVC"
          />
        </div>
      </div>
    </b-modal>
  
    </div>
  </template>
  
  <script>
  import Card from "@/components/helpers/Card";
  import Treeselect from "@riophae/vue-treeselect";
import { usersRequest } from "@/services/requests/users";
import { monthNames, dayNames } from "@/utils/utils";
import moment from "moment";
import { formatBrToEn } from '../../utils/momentHelpers';
  
  export default {
    components: { Card, Treeselect },
    name: "index",
    data() {
      return {
            monthNames,
      dayNames,
      moment,
        loading: false,
        emissor: false,
        irpf: false,
        docieIrpf: false,
        ano: null,
        lista_usuarios:[],
        cliente: null,
        ModelEmpresasRelataorio: false,
        ModelPosVendasComercial: false,
        lista_status: [
          { id: 1, label: "Processando" },
          { id: 2, label: "Aguardando assinatura" },
          { id: 3, label: "Aguardando certificado" },
          { id: 4, label: "Aguardando CNPJ" },
          { id: 5, label: "Aguardando alvará" },
          { id: 6, label: "Aguardando acesso" },
          { id: 7, label: "Aguardando simples" },
          { id: 8, label: "Aguardando Documentação" },
          { id: 9, label: "Pré-cadastro" },
          { id: 99, label: "Aguardando ativação" },
        ],
  
        form: {
          data_inicial: new Date(),
          data_final: new Date(),

          vendedor_id: null,
        },
      };
    },
    computed: {
      lista_carteiras() {
        //  return this.$store.state.carteira.lista_carteiras;
  
        return this.$store.state.carteira.lista_carteiras;
      },
    },
    created() {
      this.listar_carteiras();
    },
    methods: {
         getUsers() {
      usersRequest().then(({ data: { data } }) => {
        
        let arrayNew = [];

        for (let i = 0; i < data.length; i++) {
       if(data[i].deleted_at == null){
        
          arrayNew.push({ id: data[i].id, label: data[i].nome_completo });
        }
       }

        this.lista_usuarios = arrayNew;

      });
      this.comissao = true;
    },
     async listar_carteiras() {
       await  this.$store.dispatch("carteira/listar_carteiras");
       this.getUsers()
      },
      exportReport(param = null) {
        let filter;
        if (param != null) {
          filter = `&${param.key}=${param.value}`;
        }
        window.open(
          `${process.env.VUE_APP_API_URL}/reports/1?token=${this.$store.getters.getToken}${filter}`,
          "_blank"
        );
      },
 
      exportRelatorio(nome) {
        window.open(
          `${process.env.VUE_APP_API_URL}/relatorio/` +
            nome +
            `?token=${this.$store.getters.getToken}`,
          "_blank"
        );
      }, 
         exportRelatorio2(nome) {
        window.open(
          `${process.env.VUE_APP_API_URL}/` +
            nome +
            `?token=${this.$store.getters.getToken}`,
          "_blank"
        );
      },
      async exportPVC() {
       window.open(
        `${process.env.VUE_APP_API_URL}/empresas/poscadastro/relatorio` +
        
          `?token=${this.$store.getters.getToken}&data_inicial=${formatBrToEn(this.form.data_inicial)}&data_final=${formatBrToEn(this.form.data_final)}&vendedor_id=${this.form.vendedor_id}&carteira_id=${0}&status_id=${0}`,
        "_blank"
      );
      },
    },
  };
  </script>
  
  <style scoped>
  </style>
  